import { useState, useEffect, useRef } from 'react';

const topics = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20celebrity%20gossip%20magazine%20cover%20style%20on%20black%20background%2C%20dramatic%20lighting%20with%20neon%20green%20accents%2C%20paparazzi%20flash%20aesthetic%2C%20minimal%20composition%2C%20editorial%20photography&width=600&height=480&seq=index-topic-01-celebrity&orientation=landscape',
    tag: '明星绯闻',
    title: '娱乐圈顶流恋情追踪：最新实锤合集',
    date: '2026.07.18 更新',
    count: '2.3万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20influencer%20aesthetic%20on%20dark%20background%20with%20neon%20green%20glow%2C%20digital%20content%20creator%20vibe%2C%20minimal%20and%20modern%2C%20dark%20atmosphere&width=600&height=480&seq=index-topic-02-influencer&orientation=landscape',
    tag: '网红内幕',
    title: '头部主播塌房全记录：从巅峰到谷底',
    date: '2026.07.17 更新',
    count: '1.8万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20stage%20spotlight%20on%20dark%20background%20with%20neon%20green%20highlights%2C%20reality%20show%20aesthetic%2C%20minimal%20composition%2C%20dark%20atmosphere&width=600&height=480&seq=index-topic-03-reality&orientation=landscape',
    tag: '实锤吃瓜',
    title: '热门综艺争议全梳理：从撕番到塌房',
    date: '2026.07.16 更新',
    count: '3.1万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20breaking%20news%20aesthetic%20on%20dark%20background%20with%20neon%20green%20accents%2C%20journalism%20and%20media%20style%2C%20minimal%20composition%2C%20dark%20atmosphere&width=600&height=480&seq=index-topic-04-social&orientation=landscape',
    tag: '社会事件',
    title: '本月热搜争议事件深度复盘合集',
    date: '2026.07.15 更新',
    count: '4.5万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20secret%20document%20leak%20aesthetic%20on%20dark%20background%20with%20neon%20green%20highlights%2C%20whistleblower%20and%20expose%20style%2C%20minimal%20and%20dramatic&width=600&height=480&seq=index-topic-05-black-material&orientation=landscape',
    tag: '黑料曝光',
    title: '娱乐圈资本博弈：幕后势力的全面揭露',
    date: '2026.07.14 更新',
    count: '2.7万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20daily%20news%20flow%20on%20dark%20background%20with%20neon%20green%20accents%2C%20information%20stream%20aesthetic%2C%20minimal%20composition%2C%20dark%20atmosphere%20with%20data%20visualization&width=600&height=480&seq=index-topic-06-daily&orientation=landscape',
    tag: '每日更新',
    title: '吃瓜日报：每天一条不可错过的劲爆故事',
    date: '2026.07.18 更新',
    count: '6.2万阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Premium%20editorial%20layout%20on%20dark%20background%20with%20acid%20green%20accents%2C%20magazine%20spotlight%20style%2C%20luxury%20gossip%20magazine%20cover%20aesthetic%2C%20dramatic%20lighting%2C%20minimal%20yet%20bold%20composition&width=800&height=400&seq=index-topic-07-editorial&orientation=landscape',
    tag: '编辑精选',
    title: '2026上半年娱乐圈十大震撼事件终极盘点',
    date: '2026.07.17 更新',
    count: '12.8万阅读',
    featured: true,
  },
];

export default function TopicIndex() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const normalTopics = topics.filter((t) => !t.featured);
  const featuredTopic = topics.find((t) => t.featured);

  return (
    <section id="index" ref={sectionRef} className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
              <i className="ri-stack-line text-[10px]"></i>
              专题合集
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
              热门 <span className="font-heading italic text-accent-400">吃瓜专题</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            精选全网最火爆的爆料专题，按热度排序，每篇都是精心整理的实锤合集，让你一次吃个够。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {normalTopics.map((item, i) => (
            <a
              key={i}
              href="#index"
              className={`group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 transition-all duration-500 hover:border-accent-500/20 cursor-pointer ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="relative aspect-[5/4] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex px-2.5 py-1 bg-accent-500 text-background-950 text-[10px] font-bold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-[11px] text-foreground-600">
                  <span>{item.date}</span>
                  <span>{item.count}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {featuredTopic && (
          <a
            href="#index"
            className={`group block mt-4 md:mt-5 rounded-2xl overflow-hidden bg-background-100 border border-accent-500/10 transition-all duration-500 hover:border-accent-500/20 cursor-pointer ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '600ms' }}
          >
            <div className="flex flex-col md:flex-row">
              <div className="md:w-[45%] relative aspect-[16/9] md:aspect-auto overflow-hidden">
                <img
                  src={featuredTopic.image}
                  alt={featuredTopic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex px-3 py-1.5 bg-accent-500 text-background-950 text-xs font-bold rounded-full whitespace-nowrap">
                    {featuredTopic.tag}
                  </span>
                </div>
              </div>
              <div className="md:w-[55%] p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-bold text-foreground-50 group-hover:text-accent-400 transition-colors mb-3 leading-snug">
                  {featuredTopic.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                  涵盖从年初至今最具话题性的娱乐事件，包括明星恋情、网红翻车、综艺争议等多个维度，是你不可错过的年度吃瓜指南。
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span>{featuredTopic.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {featuredTopic.count}
                  </span>
                </div>
              </div>
            </div>
          </a>
        )}
      </div>
    </section>
  );
}